import React from "react";
import {Svg, G, Path} from "react-primitives-svg";
import PropTypes from "prop-types";
import {svgSize} from "../helpers/svg";

export default function Icon({fill, height, width, ...rest}) {
  return (
    <Svg
      {...rest}
      {...svgSize(height, width)}
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet">
      <G fillRule="evenodd">
        <Path
          id="Fill-1"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M4.66666667,10 C4.29866667,10 4,9.702 4,9.33333333 C4,8.96466667 4.29866667,8.66666667 4.66666667,8.66666667 C5.03533333,8.66666667 5.33333333,8.96466667 5.33333333,9.33333333 C5.33333333,9.702 5.03533333,10 4.66666667,10"
        />
        <Path
          id="Fill-3"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M7.33333333,10 C6.96533333,10 6.66666667,9.702 6.66666667,9.33333333 C6.66666667,8.96466667 6.96533333,8.66666667 7.33333333,8.66666667 C7.702,8.66666667 8,8.96466667 8,9.33333333 C8,9.702 7.702,10 7.33333333,10"
        />
        <Path
          id="Fill-5"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M10,10 C9.632,10 9.33333333,9.702 9.33333333,9.33333333 C9.33333333,8.96466667 9.632,8.66666667 10,8.66666667 C10.3686667,8.66666667 10.6666667,8.96466667 10.6666667,9.33333333 C10.6666667,9.702 10.3686667,10 10,10"
        />
        <Path
          id="Fill-7"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M4.66666667,12.6666667 C4.29866667,12.6666667 4,12.3686667 4,12 C4,11.6313333 4.29866667,11.3333333 4.66666667,11.3333333 C5.03533333,11.3333333 5.33333333,11.6313333 5.33333333,12 C5.33333333,12.3686667 5.03533333,12.6666667 4.66666667,12.6666667"
        />
        <Path
          id="Fill-9"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M7.33333333,12.6666667 C6.96533333,12.6666667 6.66666667,12.3686667 6.66666667,12 C6.66666667,11.6313333 6.96533333,11.3333333 7.33333333,11.3333333 C7.702,11.3333333 8,11.6313333 8,12 C8,12.3686667 7.702,12.6666667 7.33333333,12.6666667"
        />
        <Path
          id="Fill-11"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M4.66666667,15.3333333 C4.29866667,15.3333333 4,15.0353333 4,14.6666667 C4,14.298 4.29866667,14 4.66666667,14 C5.03533333,14 5.33333333,14.298 5.33333333,14.6666667 C5.33333333,15.0353333 5.03533333,15.3333333 4.66666667,15.3333333"
        />
        <Path
          id="Fill-13"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M7.33333333,15.3333333 C6.96533333,15.3333333 6.66666667,15.0353333 6.66666667,14.6666667 C6.66666667,14.298 6.96533333,14 7.33333333,14 C7.702,14 8,14.298 8,14.6666667 C8,15.0353333 7.702,15.3333333 7.33333333,15.3333333"
        />
        <Path
          id="Fill-15"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M16.6666667,16.6666667 C16.5633333,16.6666667 16.4593333,16.6426667 16.364,16.594 C16.1406667,16.4806667 16,16.2506667 16,16 L16,12 C16,11.6313333 16.298,11.3333333 16.6666667,11.3333333 C17.0353333,11.3333333 17.3333333,11.6313333 17.3333333,12 L17.3333333,14.6913333 L18.712,13.69 C19.0106667,13.474 19.4273333,13.5393333 19.6433333,13.8373333 C19.86,14.1353333 19.7933333,14.552 19.496,14.768 L17.0586667,16.5393333 C16.9426667,16.624 16.8046667,16.6666667 16.6666667,16.6666667"
        />
        <Path
          id="Fill-17"
          fill={fill && fill.outer ? fill.outer : fill}
          d="M16.6666667,20.6666667 C13.726,20.6666667 11.3333333,18.274 11.3333333,15.3333333 C11.3333333,12.3926667 13.726,10 16.6666667,10 C19.6073333,10 22,12.3926667 22,15.3333333 C22,18.274 19.6073333,20.6666667 16.6666667,20.6666667 M10.134,16.6666667 L3.33333333,16.6666667 C2.96466667,16.6666667 2.66666667,16.3686667 2.66666667,16 L2.66666667,7.33333333 L18,7.33333333 L18,8.80133333 C17.2006667,8.638 16.35,8.61733333 15.4773333,8.772 C12.5693333,9.28666667 10.3066667,11.7593333 10.03,14.6993333 C9.966,15.378 10.0066667,16.038 10.134,16.6666667 M19.3333333,9.22733333 L19.3333333,4.66666667 C19.3333333,3.564 18.436,2.66666667 17.3333333,2.66666667 L15.3333333,2.66666667 L15.3333333,4 C15.3333333,4.368 15.0353333,4.66666667 14.6666667,4.66666667 C14.2986667,4.66666667 14,4.368 14,4 L14,2.66666667 L6.66666667,2.66666667 L6.66666667,4 C6.66666667,4.368 6.36866667,4.66666667 6,4.66666667 C5.632,4.66666667 5.33333333,4.368 5.33333333,4 L5.33333333,2.66666667 L3.33333333,2.66666667 C2.23066667,2.66666667 1.33333333,3.564 1.33333333,4.66666667 L1.33333333,16 C1.33333333,17.1026667 2.23066667,18 3.33333333,18 L10.5606667,18 C11.592,20.3513333 13.9386667,22 16.6666667,22 C20.3426667,22 23.3333333,19.0093333 23.3333333,15.3333333 C23.3333333,12.606 21.6846667,10.2586667 19.3333333,9.22733333"
        />
      </G>
    </Svg>
  );
}

Icon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Icon.displayName = "Icons.Timetable";
